const SESSION_DURATION_MS = 15 * 60 * 1000;

export function metaSignupDeadline(expiresAt?: string, now = Date.now()): number {
  const deadline = expiresAt ? Date.parse(expiresAt) : NaN;
  return Number.isFinite(deadline) ? deadline : now + SESSION_DURATION_MS;
}

export function isRetryableMetaCompletionError(error: {
  status?: number;
  statusCode?: number;
  retryable?: boolean;
  reauthorizationRequired?: boolean;
}): boolean {
  if (error?.reauthorizationRequired === true) return false;
  if (typeof error?.retryable === 'boolean') return error.retryable;
  const status = Number(error?.status || error?.statusCode || 0);
  return status === 0 || status >= 500 || [408, 409, 425, 429].includes(status);
}

export function metaSignupErrorMessage(payload: any): string {
  // Error payloads can include OAuth URLs or credentials. Display only known-safe identifiers.
  const code = String(payload?.data?.error_code || payload?.data?.error?.code || payload?.error_code || '');
  const sessionId = String(payload?.data?.session_id || '');
  const safeCode = /^\d{1,10}$/.test(code) ? ` (erro ${code})` : '';
  const safeSession = /^[a-f0-9]{8}(?:-[a-f0-9]{4}){3}-[a-f0-9]{12}$/i.test(sessionId)
    ? ` Referência: ${sessionId}.` : '';
  return `A Meta não concluiu o cadastro${safeCode}.${safeSession} Tente novamente ou informe essa falha ao suporte.`;
}
